// Sparkle Hotspot v1.0.0 – 2025-08-10
(function () {
  function init(container) {
    container.querySelectorAll('.sparkle-hotspot').forEach(node => {
      const x = Number(node.dataset.x);
      const y = Number(node.dataset.y);
      if (!Number.isNaN(x)) node.style.setProperty('--x', x + '%');
      if (!Number.isNaN(y)) node.style.setProperty('--y', y + '%');
    });
  }

  // Init on DOM ready
  document.addEventListener('DOMContentLoaded', () => init(document));

  // Optional: sezione caricata dinamicamente (Shopify sections)
  document.addEventListener('shopify:section:load', e => init(e.target));
  document.addEventListener('shopify:section:select', e => init(e.target));
})();
